import { render, staticRenderFns } from "./LPHeaderMenuSp.vue?vue&type=template&id=310a249c&scoped=true"
import script from "./LPHeaderMenuSp.vue?vue&type=script&setup=true&lang=ts"
export * from "./LPHeaderMenuSp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LPHeaderMenuSp.vue?vue&type=style&index=0&id=310a249c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a249c",
  null
  
)

export default component.exports